export default {"src":"/_next/static/media/rank2.258e9b6d.svg","height":13,"width":9,"blurWidth":0,"blurHeight":0};